// extracted by mini-css-extract-plugin
export default {"link":"Link_link__CKKVF","icon":"Link_icon__vcDJI"};